import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight, Clock3 } from "lucide-react";

export const BTN_AZURE = "inline-flex items-center justify-center px-6 h-12 rounded-full font-semibold text-white bg-[#0EA5E9] hover:bg-[#0284C7] active:scale-[0.98] transition-[background-color,transform,box-shadow] shadow-md hover:shadow-[0_0_25px_rgba(14,165,233,0.35)]";
export const BTN_GHOST = "inline-flex items-center justify-center px-6 h-12 rounded-full font-semibold text-white bg-white/10 backdrop-blur border border-white/40 hover:bg-white/20 transition-colors";
export const EYEBROW_AZ = "text-xs uppercase tracking-[0.22em] font-bold text-[#0EA5E9]";
export const H2 = "text-3xl sm:text-4xl lg:text-5xl text-[#0F172A] leading-tight mt-3";

export function MonacoBadge({ t, testid = "monaco-badge" }) {
  return (
    <span className="inline-flex items-center gap-2 px-4 py-2 rounded-full text-xs font-bold bg-amber-50 text-amber-800 border border-amber-300 shadow-sm" data-testid={testid}>
      <Clock3 className="w-3.5 h-3.5" /> {t("riviera.monaco_badge")}
    </span>
  );
}

export function RivieraHero({ img, eyebrow, title, sub, children, badge, alt = "" }) {
  return (
    <section className="relative overflow-hidden min-h-[560px] lg:min-h-[640px] bg-slate-900">
      <img src={img} srcSet={img.includes("w=1600") ? `${img.replace("w=1600", "w=800")} 800w, ${img} 1600w` : undefined} sizes="100vw"
        alt={alt} aria-hidden={alt ? undefined : "true"} fetchPriority="high" className="absolute inset-0 w-full h-full object-cover" />
      <div className="absolute inset-0 bg-gradient-to-r from-[#102547]/95 via-[#1B3A6B]/75 to-slate-900/30" />
      <div className="relative max-w-7xl mx-auto px-5 md:px-8 pt-24 md:pt-32 pb-24 tl-reveal">
        <p className="text-xs uppercase tracking-[0.22em] font-bold text-sky-300">{eyebrow}</p>
        <h1 className="mt-5 text-4xl sm:text-5xl lg:text-6xl text-white leading-[1.08] max-w-3xl">{title}</h1>
        <p className="mt-6 text-base sm:text-lg text-slate-200/90 max-w-xl leading-relaxed">{sub}</p>
        {badge && <div className="mt-6">{badge}</div>}
        <div className="mt-9 flex flex-wrap gap-3">{children}</div>
      </div>
    </section>
  );
}

export function CityCard({ t, city, i = 0, to, headline, linkCls = "text-sky-300" }) {
  return (
    <Link to={to || `/fr/${city.slug}`} data-testid={`city-card-${city.slug}`}
      className="group relative block rounded-2xl overflow-hidden h-80 ring-1 ring-slate-200 tl-reveal transition-[transform,box-shadow] duration-300 hover:-translate-y-1 hover:shadow-[0_12px_40px_-4px_rgba(27,58,107,0.2)]"
      style={{ animationDelay: `${i * 70}ms` }}>
      <img src={city.image} alt={city.name} className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" />
      <div className="absolute inset-0 bg-gradient-to-t from-slate-950/85 via-slate-900/20 to-transparent" />
      {city.inquiryOnly && (
        <span className="absolute top-4 left-4 px-3 py-1 rounded-full text-[11px] font-bold bg-amber-50 text-amber-800 border border-amber-300">{t("riviera.inquiry_only")}</span>
      )}
      <div className="absolute bottom-0 inset-x-0 p-6 text-white">
        <h3 className="font-display text-3xl">{city.name}</h3>
        <p className="mt-1 text-sm text-slate-200 line-clamp-2">{headline || t(`riviera.cities.${city.slug}.headline`)}</p>
        <span className={`mt-3 inline-flex items-center gap-1.5 text-sm font-semibold ${linkCls}`}>
          {t("riviera.view_city", { city: city.name })} <ArrowRight className="w-4 h-4 transition-transform group-hover:translate-x-1" />
        </span>
      </div>
    </Link>
  );
}
